import { styled } from '@mui/material';

import { IconButton } from '@knowz/knowz-ui';

const StyledTextareaIconButton = styled(IconButton)(({ theme, disabled }) => ({
  position: 'absolute',
  right: 7.5,
  bottom: 7.5,
  '&:hover': {
    backgroundColor: 'transparent!important',
  },
  '&:focus-within': {
    outline: 'none!important',
    svg: {
      color: `${theme.palette['Colors/Effects/Focus rings/focus-ring']}!important`,
    },
  },
  svg: {
    color: disabled
      ? `${theme.palette.utility.gray400}!important`
      : `${theme.palette.utility.gray600}!important`,
  },
})) as typeof IconButton;

export default StyledTextareaIconButton;
